import { ComponentProps } from 'react';

import clsx from 'clsx';
import { PlacesType, Tooltip } from 'react-tooltip';

export type TooltipProps = {
  content: string;
  place?: PlacesType;
  offset?: number;
  delayShow?: number;
  delayHide?: number;
  followCursor?: boolean;
};

export function getAttrToShowTooltip(props: TooltipProps) {
  return {
    'data-tooltip-id': 'tooltip',
    'data-tooltip-html': props.content,
    'data-tooltip-place': props.place || 'top',
    'data-tooltip-offset': props.offset || 10,
    'data-tooltip-delay-show': props.delayShow,
    'data-tooltip-delay-hide': props.delayHide,
    'data-tooltip-float': props.followCursor,
  };
}

type StyledTooltipProps = ComponentProps<typeof Tooltip> & { $darker?: boolean };

export const StyledTooltip = ({ $darker, className, ...props }: StyledTooltipProps) => (
  <Tooltip
    className={clsx(
      $darker ? '!bg-slate-500' : '!bg-slate-400',
      'max-w-300px !px-4 !py-3 font-heebo !text-[0.875rem] font-medium leading-1.43 !text-slate-50',
      // hack to make sure the tooltip is on top of dropdowns and such. too lazy to portal it properly
      'z-1',
      className,
    )}
    {...props}
  />
);
